import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroBannerComponent } from '../../components/about/hero-banner/hero-banner.component';
import { BenefitsRequirementsComponent } from '../../components/about/benefits-requirements/benefits-requirements.component';
import { AttentionChannelsComponent } from '../../components/about/attention-channels/attention-channels.component';
import { ContactSupportComponent } from '../../components/about/contact-support/contact-support.component';
import { CTABannerComponent } from '../../components/common/cta-banner/cta-banner.component';
import { ApplyBannerComponent } from '../../components/common/apply-banner/apply-banner.component';
import { InfoAdicionalComponent } from '../../components/info-adicional/info-adicional.component';
import { FloatingButtonsComponent } from '../../components/common/floating-buttons/floating-buttons.component';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    CommonModule,
    HeroBannerComponent,
    BenefitsRequirementsComponent,
    AttentionChannelsComponent,
    ContactSupportComponent,
    CTABannerComponent,
    ApplyBannerComponent,
    InfoAdicionalComponent,
    FloatingButtonsComponent
  ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('aboutPage', { static: false }) aboutPage?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Track page view
    this.analyticsService.trackPageView('¿Qué es Unipay?', '/sobre-unipay');
  }

  ngAfterViewInit() {
    // Registrar la página completa para tracking de analytics
    if (this.aboutPage?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.aboutPage.nativeElement,
        'About Page',
        'about-page-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
